import api from '../../utils/api'

import { useState } from 'react'

/* Hooks */
import useFlashMessage from '../../hooks/useFlashMessage'

/* form */
import FormChecklistItem from './Form/FormChecklistItem'

function NewChecklistItem({ btCancelAction, handleOnSuccess }) {
    const [token] = useState(localStorage.getItem('token') || '')
    const { setFlashMessage } = useFlashMessage()

    async function registerChecklistItem(checklistItem) {
        let msgType = 'success'

        const data = await api.post('/checklistItem/new', checklistItem, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },
        }).then((response) => {
            return response.data
        }).catch((err) => {
            msgType = 'error'
            return err.response.data
        })

        setFlashMessage(data.message, msgType)

        if (msgType !== 'error') {
            handleOnSuccess()
        }
    }

    return (
        <section>
            <FormChecklistItem
                title="Novo Item de Checklist"
                handleSubmit={registerChecklistItem}
                btCancelAction={btCancelAction}
            />
        </section>
    )
}

export default NewChecklistItem
